<template>
    <div :class="shown ? 'hello-container show pt-4' : 'hello-container pt-4'">
        <div>
            <h2>{{$t('welcome_message')}}<b>{{name ? name : $t('name_missing')}}!</b></h2>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        "shown", "name"
    ]
}
</script>